import { useEffect, useState } from "react";
import { api } from "../lib/api";

export const POLL_MS = 30000;
export const RETRY_MS = 5000;

const friendlyError = (e) => {
  const status = e?.response?.status;
  if (status === 429) return "Too many requests – retrying shortly…";
  if (status) return `Server is starting up or temporarily unavailable (HTTP ${status}) – retrying…`;
  return "Cannot reach the server – retrying…";
};

export function useSnapshot(enabled = true, onUnauthorized) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    let timer = null;
    const load = async () => {
      let delay = POLL_MS;
      try {
        const r = await api.get("/snapshot");
        if (!alive) return;
        setData(r.data);
        setError(null);
      } catch (e) {
        if (!alive) return;
        if (e?.response?.status === 401) {
          onUnauthorized?.();
          return;
        }
        setError(friendlyError(e));
        delay = RETRY_MS;
      }
      if (alive) timer = setTimeout(load, delay);
    };
    load();
    return () => {
      alive = false;
      clearTimeout(timer);
    };
  }, [enabled, onUnauthorized]);

  return { data, error };
}
